import { render, staticRenderFns } from "./TeamProductieMonthlyStats.vue?vue&type=template&id=ebf3a93a"
import script from "./TeamProductieMonthlyStats.vue?vue&type=script&lang=js"
export * from "./TeamProductieMonthlyStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports